import { Context } from '@/models/order-history/status/context/context'
import { OrderCancellationState } from '../order-cancellation-state'

export abstract class CreateOrderCancellationStateCommand<T extends Context> {
  execute(context: T): OrderCancellationState {
    if (!this.shouldApply(context)) {
      throw new Error(`This command should not be executed.`)
    }

    return this.createState(context)
  }
  abstract shouldApply(context: Context): context is T
  protected abstract createState(context: T): OrderCancellationState
}
